import './Tooltip.scss';

import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import { cn } from '@/src/util/ui';
import { Portal } from '@material-ui/core';

const Tooltip = ({
  id,
  place,
  effect = 'solid',
  className = '',
  children = null,
  backgroundColor = "black",
  zIndex = 12,
  ...otherProps
}) => {
  const defaulTextColor = !className.includes('tw-text') ? 'tw-text-white' : '';

  return (
    <Portal>
      <ReactTooltip
        id={id}
        className={cn('tooltip-container', 'tw-bg-cfo-black', defaulTextColor, className)}
        style={{ padding: '10px', maxWidth: '200px', zIndex: zIndex, background: backgroundColor, lineHeight: '18px' }}
        place={place}
        effect={effect}
        delayHide={0}
        eventOff="mouseleave"
        eventOn="mouseenter focus"
        {...otherProps}
      >
        {children}
      </ReactTooltip>
    </Portal>
  );
};

export default Tooltip;
